import script from "./UndoToast.vue?vue&type=script&setup=true&lang=js"
export * from "./UndoToast.vue?vue&type=script&setup=true&lang=js"

import "./UndoToast.vue?vue&type=style&index=0&id=6c696f88&lang=css"

const __exports__ = script;

export default __exports__